import { createContext } from "react";

export type ResponsiveModalContextValue = {
  isDialog: boolean;
  setOpen?: ((open: boolean) => void) | undefined;
};

const ResponsiveModalContext = createContext<ResponsiveModalContextValue>({
  isDialog: false,
});

export { ResponsiveModalContext };
